import React from 'react'
import Link from 'components/Link'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import * as OtherIcons from 'components/Icons/Icons'
interface Social {
    Icon: React.ReactNode
    url: string
    enable: string
    color: string
    style: string
}

interface Props {
    title: string
    social: Social
}

export default function Header({ title, social }: Props) {
    return (
        <div className="flex items-center border-t border-dashed border-gray-accent-light py-4 px-6 md:justify-between md:border-b md:border-t-0">
            <h2 className="m-0 hidden text-base  opacity-70 md:block">{title}</h2>
            <ul className="flex w-full list-none justify-between space-x-4 p-0 md:w-auto md:justify-start">
                {social?.length > 0 &&
                    social.map(({ icon, url, style = '', enable, color = '' }: Social, index) => {
                        if (
                            (enable === false || enable?.toLowerCase?.() === 'false') &&
                            !process.env.RENDER_DISABLED_COMPONENTS
                        ) {
                            return <></>
                        }
                        const Icon = ProductIcons[icon] || NotProductIcons[icon] || OtherIcons[icon]
                        return (
                            <li key={index}>
                                <Link to={url}>
                                    <span className={`${color}`}>{Icon && <Icon className={`${style}`} />}</span>
                                </Link>
                            </li>
                        )
                    })}
            </ul>
        </div>
    )
}
